import Vue from 'vue';
import Router from 'vue-router';
import HomeMfe from '@/views/HomeMfe.vue';
import MyBookmarksMfe from '@/views/MyBookmarksMfe.vue';
import MyTablesMfe from '@/views/MyTablesMfe.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: HomeMfe
    },
    {
      path: '/table_detail/:cluster/:database/:schema/:name',
      redirect({ params }) {
        // ! Redirect to keep old links compatible.
        return {
          path: '/', query: {
            selectedTreeItem: `${params.cluster}.${params.database}.${params.schema}.${params.name}`
          }
        };
      }
    },
    {
      path: '/myBookmarks',
      name: 'myBookmarks',
      component: MyBookmarksMfe
    },
    {
      path: '/myDatasets',
      name: 'myDatasets',
      component: MyTablesMfe
    },
    {
      path: '/myTables',
      redirect: '/myDatasets'
    }
  ]
});
